import { render, staticRenderFns } from "./ProWhy.vue?vue&type=template&id=1dee7abc&scoped=true&"
import script from "./ProWhy.vue?vue&type=script&lang=js&"
export * from "./ProWhy.vue?vue&type=script&lang=js&"
import style0 from "./ProWhy.vue?vue&type=style&index=0&id=1dee7abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee7abc",
  null
  
)

export default component.exports